import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';

const PENDING_TOAST_KEY = 'pending_toast';
let nextId = 1;

export const enqueueToast = (payload) => {
    try {
        sessionStorage.setItem(PENDING_TOAST_KEY, JSON.stringify(payload));
    } catch {
        // sessionStorage unavailable (private mode etc.) — drop silently
    }
};

export const useToast = createGlobalState(() => {
    const toasts = ref([]);

    const hide = (id) => {
        const index = toasts.value.findIndex((t) => t.id === id);
        if (index !== -1) {
            toasts.value.splice(index, 1);
        }
    };

    const show = ({ message, variant = 'success', duration = 4000 }) => {
        const id = nextId;
        nextId += 1;
        toasts.value.push({ id, message, variant });
        if (duration > 0) {
            setTimeout(() => hide(id), duration);
        }
        return id;
    };

    const consumePending = () => {
        let raw = null;
        try {
            raw = sessionStorage.getItem(PENDING_TOAST_KEY);
            sessionStorage.removeItem(PENDING_TOAST_KEY);
        } catch {
            return;
        }
        if (!raw) return;
        try {
            show(JSON.parse(raw));
        } catch {
            // ignore malformed payload
        }
    };

    return {
        toasts,
        show,
        hide,
        consumePending,
    };
});
